export default {
  // Page title and subtitle
  'page.mainTitle': 'Konverter Timestamp Unix',
  'page.mainTitleSEO': 'Konverter Timestamp Unix & Alat Waktu Epoch',
  'page.subtitle': 'Konversi timestamp Unix ke datetime dan datetime ke timestamp secara instan',
  'page.title': 'Konverter Timestamp',
  'page.currentTimestamp': 'Timestamp Unix Saat Ini',
  'page.currentEpochTime': 'Waktu Epoch Unix Saat Ini',
  'page.milliseconds': 'Milidetik (13 digit)',
  'page.seconds': 'Detik (10 digit)',
  'page.millisecondsOnly': 'Milidetik',
  'page.secondsOnly': 'Detik',
  'page.currentDateTime': 'Tanggal & Waktu Saat Ini',

  // Interactive Converter
  'page.interactiveConverter': 'Konverter Timestamp ↔ Tanggal Interaktif',
  'page.timestampToDatetimeTitle': 'Timestamp Unix ke Datetime',
  'page.datetimeToTimestampTitle': 'Datetime ke Timestamp',
  'page.ms': 'MS',
  'page.sec': 'DET',
  'page.autoDetect': 'Deteksi format otomatis',
  'page.detected': 'Terdeteksi',
  'page.digits': 'digit',
  'page.convertedTo': 'Dikonversi ke',
  'page.converterTip': 'Konversi Dua Arah Real-time',
  'page.converterTipDesc': 'Ketik di salah satu bidang untuk langsung melihat konversi. Secara otomatis mendeteksi timestamp 10-digit (detik) atau 13-digit (milidetik).',

  // Conversion sections
  'page.timestampToDateTime': 'Timestamp ke Tanggal Waktu',
  'page.dateTimeToTimestamp': 'Tanggal Waktu ke Timestamp',
  'page.selectFormat': 'Pilih Format',
  'page.enterTimestamp': 'Masukkan timestamp',
  'page.enterDateTime': 'Pilih tanggal dan waktu',
  'page.convertedResult': 'Hasil Konversi',
  'page.yourTimeZone': 'Zona Waktu Anda',
  'page.relative': 'Relatif',

  // Relative time translations
  'page.relativeTime.secondsAgo': '{{seconds}} detik yang lalu',
  'page.relativeTime.minutesAgo': '{{minutes}} menit yang lalu',
  'page.relativeTime.hoursAgo': '{{hours}} jam yang lalu',
  'page.relativeTime.daysAgo': '{{days}} hari yang lalu',
  'page.relativeTime.inSeconds': 'dalam {{seconds}} detik',
  'page.relativeTime.inMinutes': 'dalam {{minutes}} menit',
  'page.relativeTime.inHours': 'dalam {{hours}} jam',
  'page.relativeTime.inDays': 'dalam {{days}} hari',

  // What is Timestamp section (FAQ)
  'page.faq': 'Pertanyaan yang Sering Diajukan (FAQ)',
  'page.whatIsTimestamp': 'Apa itu Timestamp Unix?',
  'page.timestampIntro': 'Timestamp Unix (juga dikenal sebagai waktu Epoch atau waktu POSIX) adalah sistem untuk mendeskripsikan titik waktu sebagai jumlah detik (atau milidetik) yang telah berlalu sejak 00:00:00 UTC pada 1 Januari 1970 (epoch Unix), tidak menghitung detik kabisat. Standar ini banyak digunakan dalam komputasi dan pemrograman sebagai cara sederhana dan universal untuk merepresentasikan tanggal dan waktu.',

  'page.unixEpochTitle': 'Unix Epoch - Awal Waktu',
  'page.unixEpochDesc': 'Epoch Unix adalah tengah malam UTC pada 1 Januari 1970. Semua timestamp Unix dihitung dari momen spesifik ini, menjadikannya titik referensi universal untuk sistem komputer di seluruh dunia.',

  'page.timestampFormatsTitle': 'Format Timestamp',
  'page.secondsFormat': 'Detik (10-digit)',
  'page.secondsFormatDesc': 'Timestamp Unix standar yang mewakili detik sejak epoch. Contoh: 1734598784',
  'page.millisecondsFormat': 'Milidetik (13-digit)',
  'page.millisecondsFormatDesc': 'Timestamp yang diperluas dengan presisi milidetik. Contoh: 1734598784000',

  'page.whyUseTimestampTitle': 'Mengapa kita menggunakan Waktu Unix?',
  'page.reason1Title': 'Independen Zona Waktu',
  'page.reason1Desc': 'Timestamp mewakili waktu UTC, menghilangkan kebingungan zona waktu dalam aplikasi global.',
  'page.reason2Title': 'Perhitungan Mudah',
  'page.reason2Desc': 'Operasi aritmatika sederhana untuk menghitung perbedaan waktu dan durasi.',
  'page.reason3Title': 'Ramah Database',
  'page.reason3Desc': 'Format penyimpanan integer kompak yang sempurna untuk indeks dan pengurutan database.',
  'page.reason4Title': 'Standar Universal',
  'page.reason4Desc': 'Didukung oleh hampir semua bahasa pemrograman dan platform.',
  'page.year2038Problem': 'Apa yang terjadi pada tahun 2038? (Masalah Tahun 2038)',
  'page.year2038Content': 'Masalah Tahun 2038 (juga dikenal sebagai Y2038 atau Bug Milenium Unix) mengacu pada waktu ketika timestamp Unix 32-bit akan meluap. Pada 19 Januari 2038, pukul 03:14:07 UTC, integer bertanda 32-bit akan mencapai nilai maksimum (2.147.483.647) dan berputar ke angka negatif. Sistem modern yang menggunakan timestamp 64-bit tidak terpengaruh dan dapat merepresentasikan tanggal miliaran tahun ke depan.',

  // Coding examples section
  'page.codingExamples': 'Cara Mendapatkan Timestamp Saat Ini dalam Berbagai Bahasa Pemrograman',
  'page.codeCheatSheet': 'Cheat Sheet Kode Timestamp Unix (Berdasarkan Bahasa)',
  'page.howToGetTimestamp': 'Cara Mendapatkan Timestamp Saat Ini',
  'page.convertToDate': 'Konversi Timestamp ke Objek Tanggal',
  'page.convertToTimestamp': 'Konversi Tanggal ke Timestamp',
  'page.getCurrentTimestamp': 'Dapatkan Timestamp Saat Ini',
  'page.getMilliseconds': 'Dapatkan timestamp milidetik',
  'page.getSeconds': 'Dapatkan timestamp detik',

  // Timestamp to Date conversion examples
  'page.timestampToDateExamples': 'Cara Mengkonversi Timestamp Unix ke Tanggal/Waktu',
  'page.timestampToDateDesc': 'Pelajari cara mengkonversi timestamp Unix ke format tanggal dan waktu yang dapat dibaca manusia dalam berbagai bahasa pemrograman. Baik Anda memiliki timestamp detik atau milidetik, contoh-contoh ini menunjukkan metode konversi yang tepat.',
  'page.convertTimestampToDate': 'Konversi Timestamp ke Tanggal',
  'page.fromMilliseconds': 'Dari timestamp milidetik',
  'page.fromSeconds': 'Dari timestamp detik',
  'page.formatOptions': 'Format dengan opsi kustom',
  'page.toUTC': 'Konversi ke UTC',
  'page.formatDate': 'Format tanggal',

  // Date to Timestamp conversion examples
  'page.dateToTimestampExamples': 'Cara Mengkonversi Tanggal/Waktu ke Timestamp Unix',
  'page.dateToTimestampDesc': 'Pelajari cara mengkonversi tanggal dan waktu ke timestamp Unix dalam berbagai bahasa pemrograman. Contoh-contoh ini mendemonstrasikan parsing string tanggal, membuat timestamp dari komponen tanggal, dan menangani format detik dan milidetik.',
  'page.convertDateToTimestamp': 'Konversi Tanggal ke Timestamp',
  'page.fromDateString': 'Dari string tanggal',
  'page.fromDateComponents': 'Dari komponen tanggal',
  'page.parseString': 'Parse string tanggal',
  'page.monthNote': 'Catatan: bulan dimulai dari indeks 0',
  'page.useCalendar': 'Menggunakan Calendar',
  'page.parseFormat': 'Parse dengan format',
  'page.fromComponents': 'Dari komponen waktu',
  'page.currentTime': 'Dapatkan timestamp saat ini',
  'page.fromDatetime': 'Dari kolom datetime',

  // How to use
  'page.howToUse': 'Cara Menggunakan Konverter Timestamp Ini',
  'page.step1': '📊 Timestamp Saat Ini: Lihat timestamp Unix real-time dalam format detik (10 digit) dan milidetik (13 digit). Klik tombol salin untuk dengan cepat menyalin timestamp ke clipboard Anda.',
  'page.step2': '🔄 Timestamp ke DateTime: Masukkan timestamp Unix dan pilih apakah dalam format detik atau milidetik. Klik konversi untuk melihat tanggal dan waktu yang sesuai dalam berbagai format termasuk GMT, zona waktu lokal Anda, ISO 8601, dan waktu relatif.',
  'page.step3': '📅 DateTime ke Timestamp: Pilih tanggal dan waktu apa pun menggunakan pemilih tanggal, atau klik "Sekarang" untuk menggunakan waktu saat ini. Konversi untuk mendapatkan format timestamp detik dan milidetik secara instan.',
  'page.step4': '💡 Tips Cepat: Timestamp Unix adalah jumlah detik/milidetik sejak 1 Januari 1970 00:00:00 UTC. Gunakan format 10-digit untuk detik, 13-digit untuk milidetik. Semua konversi bersifat instan dan bekerja offline.',

  // Related Tools
  'page.relatedTools': 'Alat Waktu Terkait',
  'page.relatedToolsDesc': 'Jelajahi alat manajemen waktu profesional kami yang lain',
  'page.timerTool': 'Timer Online',
  'page.timerToolDesc': 'Timer hitung mundur sempurna untuk teknik Pomodoro, memasak, belajar, dan istirahat kerja',
  'page.stopwatchTool': 'Stopwatch',
  'page.stopwatchToolDesc': 'Stopwatch presisi tinggi dengan akurasi milidetik untuk pelatihan olahraga dan pengaturan waktu',
  'page.worldClockTool': 'Jam Dunia',
  'page.worldClockToolDesc': 'Jam dunia real-time yang menampilkan waktu saat ini di kota-kota besar di seluruh dunia',

  // Specialized Tools
  'page.specializedTools': 'Alat Timestamp Khusus',
  'page.specializedToolsDesc': 'Jelajahi alat timestamp khusus untuk berbagai platform dan kasus penggunaan',
  'page.discord.desc': 'Hasilkan kode <t:format> dengan konversi zona waktu otomatis untuk acara Discord',
  'page.discord.topSearch': 'Pencarian Teratas',
  'page.discord.searchesPerMonth': 'pencarian/bulan',
  'page.youtube.desc': 'Buat tautan YouTube yang dapat dibagikan yang dimulai pada waktu tertentu',
  'page.youtube.popular': 'Populer',

  // Programming Guides
  'page.programmingGuides': 'Panduan Timestamp Bahasa Pemrograman',
  'page.programmingGuidesDesc': 'Pelajari metode penanganan timestamp, fungsi, dan praktik terbaik untuk setiap bahasa pemrograman',
  'page.sql.desc': 'Penanganan timestamp MySQL, PostgreSQL, Oracle, SQL Server',
  'page.sql.highPriority': 'Prioritas Tinggi',
  'page.sql.searches': 'pencarian',
  'page.python.desc': 'Panduan modul datetime, time, calendar',
  'page.python.popular': 'Populer',
  'page.javascript.desc': 'Panduan objek Date, library Day.js, date-fns',
  'page.javascript.common': 'Umum',
  'page.codeExamplesNote': 'Termasuk contoh kode lengkap, praktik terbaik, dan FAQ',
};
